import type { Timeseries } from '@cognite/sdk';
import { useTrendColor } from '@infield/features/trends';

import type {
  EnhancedTimeseries,
  TimeseriesWithColor,
  TimeseriesWithYSubDomain,
} from '../../types';

// NOTE: The typing of this function is currently inconsistent due to legacy usage across the codebase.
// In some cases (e.g., Asset Trend Card), it receives a basic `Timeseries` and returns a `TimeseriesWithColor`.
// In others (e.g., Trends Chart), it works with a `TimeseriesWithYSubdomain` and returns an `EnhancedTimeseries`.
// This will be cleaned up as part of the following ticket:
// TODO: https://cognitedata.atlassian.net/browse/FO-721
export const colorTimeseries = (
  timeseries: TimeseriesWithYSubDomain[] | Timeseries[]
): EnhancedTimeseries[] | TimeseriesWithColor[] =>
  timeseries.map((serie) => ({
    color: useTrendColor(serie.name),
    ...serie,
  }));
